import { Provider } from "@angular/core";
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from "@angular/material/snack-bar";

export const snackBarOptions: Provider = {
  provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
  useValue: { duration: 5000, panelClass: 'vertical-view', verticalPosition: 'top' }
}
